import ServicePage from "../components/ServicePage";

export default function CreazioneSitiWebNovara() {
  return (
    <ServicePage
      seo={{
        title: "Creazione Siti Web a Novara | Siti Professionali per Attività Locali — Lumora",
        description:
          "Creazione siti web a Novara per piccole attività e professionisti. Design su misura, dominio e hosting inclusi, gestione mensile. Preventivo gratuito in 24 ore.",
        path: "/creazione-siti-web-novara",
      }}
      kicker="Creazione siti web · Novara"
      h1="Creazione siti web a Novara, su misura per la tua attività"
      lead="Siamo uno studio web di Novara e creiamo siti professionali per attività locali, professionisti e piccole imprese. Niente template preconfezionati: ogni sito è disegnato e sviluppato su misura, pensato per essere veloce, bello e facile da trovare su Google."
      features={[
        "Design personalizzato: il tuo sito non assomiglierà a nessun altro, perché parte dalla tua attività e dai tuoi clienti.",
        "Dominio, hosting e certificato di sicurezza inclusi: non devi gestire nessun fornitore tecnico.",
        "Sito veloce e perfetto da smartphone, dove oggi arriva la maggior parte dei tuoi visitatori.",
        "Testi e struttura pensati per Google fin dal primo giorno, con titoli e contenuti ottimizzati.",
        "Pronto in poche settimane: un processo chiaro con una demo da vedere e approvare prima del lancio.",
        "Dopo il lancio non resti solo: gestione, aggiornamenti e assistenza con un unico abbonamento mensile.",
      ]}
      priceTitle="Creazione da €1.000 una tantum, gestione da €79/mese"
      priceDesc="Un investimento chiaro, senza sorprese: la creazione si paga una sola volta, la gestione mensile copre hosting, sicurezza, backup, aggiornamenti e assistenza. Per le piccole attività di Novara e provincia c'è anche il nostro programma agevolato con prezzo ridotto."
      faqs={[
        {
          q: "Quanto costa un sito web a Novara?",
          a: "La creazione parte da €1.000 una tantum, con gestione mensile da €79 che include hosting, sicurezza e aggiornamenti. Per le piccole attività locali valutiamo tariffe agevolate: raccontaci la tua realtà dal modulo Agevolazioni.",
        },
        {
          q: "Quanto tempo serve per avere il sito online?",
          a: "In genere poche settimane: dopo la prima chiacchierata prepariamo una demo che puoi vedere e provare, la perfezioniamo insieme e poi andiamo online.",
        },
        {
          q: "Devo occuparmi io di dominio, hosting o email?",
          a: "No. Registrazione dominio, hosting, certificato di sicurezza e ogni aspetto tecnico sono gestiti interamente da noi, inclusi nella gestione mensile.",
        },
        {
          q: "Il sito sarà mio o vostro?",
          a: "Il sito è tuo. Anche se un giorno decidessi di interrompere la gestione mensile, il lavoro di creazione resta di tua proprietà.",
        },
      ]}
      related={[
        { path: "/web-design-novara", label: "Web design a Novara" },
        { path: "/seo-novara", label: "SEO a Novara" },
        { path: "/gestione-siti-web", label: "Gestione siti web" },
      ]}
    />
  );
}
